import { Injectable } from "@angular/core";
import { IID_EP_TICKET } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDepTicketStore } from "./iidEpTicket.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.EP_TICKET)
export class IIDepTicketQuery extends AbstractInterfaceDataQuery<IID_EP_TICKET> {
  constructor(protected store: IIDepTicketStore) {
    super(store);
  }
}
